module.exports = __webpack_public_path__ + "img/migration-service-help.3f9c15fb.png";